import { render, staticRenderFns } from "./PlayerScore.vue?vue&type=template&id=3f783a97&"
import script from "./PlayerScore.vue?vue&type=script&lang=ts&"
export * from "./PlayerScore.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports